import { render } from "./PrecioProducto.vue?vue&type=template&id=3b79cf00&scoped=true"
import script from "./PrecioProducto.vue?vue&type=script&lang=js"
export * from "./PrecioProducto.vue?vue&type=script&lang=js"

import "./PrecioProducto.vue?vue&type=style&index=0&id=3b79cf00&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b79cf00"]])

export default __exports__